import React from 'react'
import { connect } from 'react-redux'
import context from '@/context'
import { actionCreators, getAvailableParents } from '@/store/OrganizationalUnits'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import Resx from '@/components/Resx'
import { BsrsGrid, LookupCell, createLookupFilterCell } from '@/components/BsrsGrid'
import { TabContent, TabPane } from 'reactstrap'
import { Main, MainTop, MainTopTitle, MainBody, MainTopLeft, WhiteBox } from '@/components/Layout'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { localized } from '@/decorators/localized'
import OrganizationalUnitTreeView from './treeView/OrganizationalUnitTreeView'
import { TabNavItems } from '@/components/tabs'
import { Button } from '@/components/button'
import { dialogTypes } from '@/dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'
import { getOrganizationUnitGridButtons } from './gridButtons'
import { withPermissions } from '@/decorators/withPermissions'

const TABS = {
  GRID: 0,
  TREE: 1
}

@localized()
@withPermissions()
class List extends React.Component {
  state = {
    activeTab: TABS.GRID,
    id: null
  }

  componentDidMount () {
    this.props.getAll()
  }

  toggleTab (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }

  render () {
    const { localize, loading, units, treeData, openDialog, create } = this.props
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='OrganizationalUnit.Title' />
          </MainTopTitle>
          <MainTopLeft>
            {this.props.isGranted('CanManageOrganizationalUnits') && <Button icon='plus' color='primary' className='btn-sm' onClick={() => openDialog({
              dialogType: dialogTypes.organizationalUnit,
              availableParents: getAvailableParents(treeData),
              units: units,
              onAction: create
            })}>
              <span><Resx name='OrganizationalUnit.CreateOrganizationalUnit' /></span>
            </Button>}
          </MainTopLeft>
        </MainTop>
        <MainBody transparent>{loading
          ? <LoadingIndicator />
          : <WhiteBox>
            <TabNavItems activeTabId={this.state.activeTab} onClick={activeTab => this.setState({ activeTab })} items={[
              { id: TABS.GRID, text: 'OrganizationalUnit.TableView', icon: 'table' },
              { id: TABS.TREE, text: 'OrganizationalUnit.TreeView', icon: 'sitemap' }
            ]} />
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId={TABS.GRID}>
                <BsrsGrid persistenceId={'organizational-units'} items={units}>
                  <Column field='unitType' title={localize('OrganizationalUnit.Type')} cell={LookupCell} filterCell={createLookupFilterCell(context.cache.getOrganizationalUnitType)} width='150px' />
                  <Column field='code' title={localize('OrganizationalUnit.Code')} width='150px' />
                  <Column field='name' title={localize('OrganizationalUnit.Name')} />
                  <Column field='latinName' title={localize('OrganizationalUnit.LatinName')} />
                  <Column field='reference' title={localize('OrganizationalUnit.Reference')} />
                  <Column field='parent' title={localize('OrganizationalUnit.SuperiorOrganizationalUnitName')} cell={LookupCell} filterCell={createLookupFilterCell(context.api.organizationalUnitService.getLookup, { filterData: {}, transform: r => r.data })} />
                  <Column width='45px' {...getOrganizationUnitGridButtons(this.props.delete, this.props.isGranted('CanManageOrganizationalUnits'))} />
                </BsrsGrid>
              </TabPane>
              <TabPane tabId={TABS.TREE}>
                <OrganizationalUnitTreeView />
              </TabPane>
            </TabContent>
          </WhiteBox>}
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state) => {
  const { loading, units, treeData } = state.organizationalUnits
  return {
    loading, units, treeData
  }
}

const mapDispatchToProps = {
  getAll: actionCreators.getAll,
  create: actionCreators.create,
  delete: actionCreators.delete,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/list.js